import { Input, Popover } from 'antd';
import { ReactComponent as FlightGoingIcon } from 'app/assets/img/iconFlightGoing.svg';
import { ReactComponent as MapPinIcon } from 'app/assets/img/iconMapPin.svg';
import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectTranslations } from '../App/slice/selectors';
import { IRegion, TypePoint } from '../BookingMask';
import { LoadingContainer } from 'app/components/LoadingContainer';
interface AirportSelectPopoverProps {
  type: TypePoint;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  textValue: string;
  onTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isSearching: boolean;
  regions: IRegion[];
  selectedRegion?: IRegion;
  selectedAirport?: any;
  excludedAirportCode?: string;
  dataSearchAirports: any[];
  onSelectRegion: (region: IRegion) => void;
  onSelectAirport: (airport: any) => void;
  popupContainerRef: React.RefObject<HTMLDivElement>;
  device: 'desktop' | 'mobile' | 'tablet';
  windowWidth: number;
  placeholder: string;
  isDisabled: boolean;
  isLoading?: boolean;
}

const AirportSelectPopover: React.FC<AirportSelectPopoverProps> = ({
  type,
  isOpen,
  onOpenChange,
  textValue,
  onTextChange,
  isSearching,
  regions,
  selectedRegion,
  selectedAirport,
  excludedAirportCode,
  dataSearchAirports,
  onSelectRegion,
  onSelectAirport,
  popupContainerRef,
  device,
  windowWidth,
  placeholder,
  isDisabled,
  isLoading,
}) => {
  const translations = useSelector(selectTranslations);
  const formatAirportName = airport =>
    [
      airport?.name &&
        `${airport.name}${airport.code ? ` (${airport.code})` : ''}`,
      airport?.countryName,
    ]
      .filter(Boolean)
      .join(', ');
  const isExcludedAirport = (airport: { code?: string }) =>
    !!excludedAirportCode && airport.code === excludedAirportCode;

  const renderDefaultContent = () => {
    const dataAirports = selectedRegion?.airports?.filter(
      airport => !isExcludedAirport(airport),
    );
    return (
      <LoadingContainer loading={isLoading}>
        {!isLoading && (
          <div className="contentPopover">
            <div className="contentPopoverLeft">
              {regions.map(region => (
                <div
                  key={region.id}
                  className="boxRegion"
                  data-active={selectedRegion?.id === region.id}
                  onClick={() => onSelectRegion(region)}
                >
                  {region.name}
                </div>
              ))}
            </div>
            <div className="contentPopoverRight">
              {_.isEmpty(dataAirports) && (
                <div
                  style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {translations?.['b2b.txt.haveNoData']}
                </div>
              )}

              {dataAirports?.map(airport => {
                const name = formatAirportName(airport);
                return (
                  <div
                    key={airport.id}
                    className="boxAirport"
                    data-active={selectedAirport?.id === airport.id}
                    onClick={() => onSelectAirport(airport)}
                  >
                    {name}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </LoadingContainer>
    );
  };

  const renderSearchContent = () => {
    const keyword = textValue.toLowerCase();
    const filtered = dataSearchAirports.filter(
      a =>
        !isExcludedAirport(a) &&
        (a.name?.toLowerCase().includes(keyword) ||
          a.code?.toLowerCase().includes(keyword)),
    );
    return (
      <div className="contentPopover">
        <div className="contentPopoverRight">
          {_.isEmpty(filtered) && (
            <div
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {translations?.['b2b.txt.haveNoData']}
            </div>
          )}

          {filtered.map(item => {
            const name = formatAirportName(item);
            return (
              <div
                key={item.id}
                className="boxAirport"
                data-active={selectedAirport?.id === item.id}
                onClick={() => onSelectAirport(item)}
              >
                {name}
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  return (
    <>
      <PopupContainer ref={popupContainerRef} />
      <StyledPopover
        getPopupContainer={() => popupContainerRef.current!}
        placement="bottomLeft"
        trigger="click"
        visible={isOpen}
        onVisibleChange={onOpenChange}
        overlayInnerStyle={{
          borderRadius: '10px',
          width: device === 'desktop' ? windowWidth * 0.5 : windowWidth * 0.95,
          padding: 0,
        }}
        content={isSearching ? renderSearchContent() : renderDefaultContent()}
      >
        <div
          className="boxPoint"
          style={{ paddingLeft: type === 'destination' ? 14 : 0 }}
        >
          {type === 'departure' && <FlightGoingIcon />}
          {type === 'destination' && <MapPinIcon />}
          <InputWrapper>
            <StyledInput
              value={textValue}
              placeholder={placeholder}
              width="100%"
              onChange={onTextChange}
              disabled={isDisabled}
            />
          </InputWrapper>
        </div>
      </StyledPopover>
    </>
  );
};
export default AirportSelectPopover;
const StyledPopover = styled(Popover)`
  .ant-popover-inner {
    background-color: lightblue !important;
  }
`;
const PopupContainer = styled.div`
  & > div:first-child {
    z-index: 1;
  }
`;
const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
const StyledInput = styled(Input)`
  width: 100%;
  border: none;
  background-color: transparent;
  border-bottom: 0px solid transparent;
  font-size: 14px;
  :focus-visible {
    outline: none;
    border-bottom: 0px solid transparent;
    border: none;
    box-shadow: none;
  }
  &:hover {
    outline: none;
    border-bottom: 0px solid transparent;
    border: none;
  }
  ::placeholder {
    font-style: italic;
    font-weight: 400;
  }
  :disabled {
    background-color: transparent;
    border-bottom: 0px solid transparent;
  }
`;
